import React from "react";
import { Div, Text, Input, Button, Image } from "atomize";
import InnerHTML from "../../utilities/innerHtml";
import WebsiteContainer from "./WebsiteContainer";
import CustomContainer from "./CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl, updateActiveCampaignForm } from "../../utilities/helpers";
import SolutionsPagesButton from "./SolutionsPagesButtons";

class SolutionsLearnMore extends React.Component {
  render() {
    const { content, form } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div
            d="flex"
            flexDir={{ xs: "column", md: "row" }}
            justify="space-between"
            bg="primary"
            p={{
              x: { xs: "1.56rem", md: "2.82rem" },
              y: { xs: "3.4rem", md: "3.125rem" },
            }}
          >
            <Div
              flexGrow="1.2"
              d="flex"
              flexDir="column"
              justify="space-between"
            >
              <Text
                m={{ b: { xs: "4.25rem", md: "2.5rem" } }}
                textSize="title2"
                textWeight="700"
                textColor="black"
                tag="h2"
              >
                {content.title}
              </Text>

              <Div
                p={{ l: { xs: "0", md: "4rem" } }}
                d={{ md: "none" }}
                m={{ b: { xs: "2.25rem", md: "4rem" } }}
                flexGrow="1"
              >
                <Text
                  m={{ b: ".8rem" }}
                  maxW="21.75rem"
                  textSize="subheader5"
                  style={{ lineHeight: "24px" }}
                  textColor="black"
                  textWeight="700"
                >
                  “{content.testimonial.quote}”
                </Text>
                <Div d="flex">
                  <ImageLink link={content.testimonial.userImageLink}>
                    <Image
                      m={{ r: "1rem" }}
                      h="3.75rem"
                      w="3.75rem"
                      bgSize="contain"
                      alt={content.testimonial.alt && content.testimonial.alt}
                      src={content.testimonial.userImage}
                    />
                  </ImageLink>
                  <Div p={{ y: ".5rem" }}>
                    <Text
                      textColor="black"
                      textWeight="700"
                      fontFamily="secondary"
                    >
                      {content.testimonial.userName}
                    </Text>
                    <Text
                      textColor="black"
                      fontFamily="secondary"
                      textSize="caption"
                      textWeight="700"
                    >
                      {content.testimonial.designation}
                    </Text>
                  </Div>
                </Div>
              </Div>

              <Div m={{ b: { md: ".5rem" } }}>
                <Text
                  m={{ b: { xs: ".6rem", md: ".8rem" } }}
                  textColor="black"
                  fontFamily="secondary"
                  textWeight="700"
                  d={{ xs: "none", md: "block" }}
                >
                  {content.inputLabel}
                </Text>
                <SolutionsPagesButton bgColor="black" textColor="white" />
                {/* <Div m={{ r: { xs: "0", md: "3rem" } }}>
                  {typeof window !== "undefined" && (
                    <InnerHTML html={updateActiveCampaignForm(form)} />
                  )}
                  
                </Div> */}
                {/* <Input
                  m={{ r: {xs: "0", md: "3rem" }}}
                  placeholder="youremail@email.com"
                  rounded="xs"
                  fontFamily="secondary"
                  textSize="caption2"
                  h="3.125rem"
                  border="none"
                  shadow="1"
                  suffix={
                    <Button
                      pos="absolute"
                      onClick={() => console.log("clicked")}
                      bg="black"
                      hoverBg="black"
                      top="0"
                      right="0"
                      textSize={{ xs: "caption2", md: "14px" }}
                      h="3.125rem"
                      p={{ x: { xs: "1.3rem", md: "1.9rem" } }}
                      textWeight="700"
                      fontFamily="secondary"
                      rounded={{ r: "xs" }}
                    >
                      Learn More
                    </Button>
                  }
                /> */}
              </Div>
            </Div>
            <Div p={{ l: "4rem" }} d={{ xs: "none", md: "block" }} flexGrow="1">
              <Text
                m={{ b: "1.1rem" }}
                maxW="21.8rem"
                textSize="subheader5"
                style={{ lineHeight: "24px" }}
                textColor="black"
                textWeight="700"
              >
                “{content.testimonial.quote}”
              </Text>
              <Div d="flex">
                <ImageLink link={content.testimonial.userImageLink}>
                  <Image
                    m={{ r: "1rem" }}
                    alt={content.testimonial.alt && content.testimonial.alt}
                    h="3.75rem"
                    w="3.75"
                    bgSize="contain"
                    src={content.testimonial.userImage}
                  />
                </ImageLink>
                <Div p={{ y: ".5rem" }}>
                  <Text
                    textColor="black"
                    textWeight="700"
                    fontFamily="secondary"
                  >
                    {content.testimonial.userName}
                  </Text>
                  <Text
                    textColor="black"
                    fontFamily="secondary"
                    textSize="caption"
                    textWeight="700"
                  >
                    {content.testimonial.designation}
                  </Text>
                </Div>
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}

export default SolutionsLearnMore;
